"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNextGenTheme = void 0;
const styles_1 = require("@mui/material/styles");
const colors = require("@ansarada/colors");
const utils_1 = require("../utils");
function createPalette(mode) {
    return {
        primary: {
            main: colors.brand500,
            dark: colors.brand550,
        },
        secondary: {
            main: colors.brand600,
        },
        error: {
            main: colors.functionalRed600,
            contrastText: colors.white,
        },
        warning: {
            main: colors.citrus,
            light: colors.mandarine,
            contrastText: colors.textBase,
        },
        info: {
            main: colors.dawn,
            light: colors.berry,
            contrastText: colors.textBase,
        },
        success: {
            main: colors.functionalGreen500,
            contrastText: colors.white,
        },
        mode,
        common: {
            black: colors.black,
            white: colors.white,
        },
        text: {
            primary: mode === 'light' ? colors.textBase : colors.textWhite,
            secondary: mode === 'light' ? colors.textLight : colors.textWhite,
        },
        grey: {
            100: colors.neutral100,
            200: colors.neutral200,
            300: colors.neutral300,
            400: colors.neutral400,
            500: colors.neutral500,
            600: colors.neutral600,
        },
        divider: colors.neutral300,
    };
}
function createTypography() {
    return {
        fontFamily: 'aktiv-grotesk, Helvetica, Arial, sans-serif',
    };
}
function createNextGenTheme({ name, mode }) {
    const themeOptions = {
        name,
        typography: createTypography(),
        palette: createPalette(mode),
        components: {
            MUIRichTextEditor: {
                styleOverrides: {
                    root: Object.assign({ border: `1px solid ${colors.neutral300}`, borderRadius: 4 }, (0, utils_1.unsafeCssProperties)({
                        '&:hover': {
                            borderColor: colors.textBase,
                        },
                        '&:focus-within': {
                            borderColor: colors.brand500,
                        },
                    })),
                    container: {
                        margin: 0,
                    },
                    editorContainer: {
                        margin: 0,
                        padding: 16,
                        boxSizing: 'border-box',
                    },
                    placeHolder: {
                        position: 'static',
                    },
                },
            },
            MuiDropzoneArea: {
                styleOverrides: {
                    root: {
                        minHeight: 0,
                        borderColor: 'transparent',
                        backgroundColor: colors.neutral100,
                    },
                    text: {
                        marginTop: 0,
                        marginBottom: 0,
                        fontSize: 16,
                    },
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        boxShadow: 'none',
                        border: '1px solid #B4BABB',
                    },
                },
            },
            MuiAlert: {
                styleOverrides: {
                    root: {
                        backgroundColor: '#F4F8F8',
                    },
                },
            },
            MuiTabs: {
                styleOverrides: {
                    indicator: {
                        backgroundColor: 'primary.main',
                    },
                },
            },
            MuiTab: {
                styleOverrides: {
                    root: {
                        fontSize: 15,
                        fontWeight: 700,
                        textTransform: 'none',
                        color: '#717676',
                        '&.Mui-selected': {
                            color: '#07070C',
                        },
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontSize: 15,
                        lineHeight: '26px',
                        textTransform: 'none',
                    },
                    contained: {
                        boxShadow: 'none',
                        '&:hover': {
                            boxShadow: 'none',
                        },
                    },
                },
            },
        },
    };
    return (0, styles_1.createTheme)(themeOptions);
}
exports.createNextGenTheme = createNextGenTheme;
//# sourceMappingURL=next-gen.js.map